import styled from 'styled-components'

type Props = {
	isHidden?: boolean
}

export const FieldWrapper = styled.div<Props>`
	display: block;
	height: ${({ isHidden }) => (isHidden ? 0 : 'auto')};
	margin-bottom: ${({ isHidden }) => (isHidden ? 0 : '20px')};
	overflow: ${({ isHidden }) => (isHidden ? 'hidden' : 'visible')};

	&:only-child {
		margin-bottom: 0;
	}
`
